import React from 'react'
import {withRouter} from 'react-router-dom'

class HouseCard extends React.Component{

    handleClick = () => {
        this.props.history.push('/house/'+this.props.house._id)
    }

    render(){
        return (
        <div id={this.props.house.name} className="card shadow m-3" style={{width: 100 + '%'}}>
            <div className="card-body">
                <h2 className="card-title">{this.props.house.name}</h2>
                <p className="card-text">
                    Mascot : {this.props.house.mascot} <br/>
                    Founder : {this.props.house.founder} <br/>
                    Head master : {this.props.house.headOfHouse} <br/>
                    School : {this.props.house.school}
                    </p>
                <button href="#" className="btn btn-dark text-white" onClick={this.handleClick}>Details</button>
            </div>
        </div>
        )
    }
}

export default withRouter(HouseCard)